import type { Reference } from '@apollo/client';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  CollectionShare: {
    fields: {
      appearance: {
        read: (appearance, { readField, mergeObjects }) => {
          const collectionRef: Reference = readField('collection');

          if (!collectionRef) {
            return appearance;
          }

          const collectionAppearance = readField<typeof appearance>(
            'appearance',
            collectionRef
          );
          return appearance;

          /**
           * @note Return the `appearance` field of the CollectionShare with a fragment
           * of the parent collection's appearance, except for the layout. The layout can
           * still be configured by the Share.
           */
          if (readField('useOriginHeader') && collectionAppearance) {
            const collectionFragmentWithShareLayout = {
              ...collectionAppearance,
              layout: appearance.layout,
            };

            return mergeObjects(appearance, collectionFragmentWithShareLayout);
          }

          return appearance;
        },
      },
      name: {
        read: (name, { readField, canRead }) => {
          const collectionRef: Reference = readField('collection');

          /** Forward a synced CollectionShare's name to the associated collection. */
          if (canRead(collectionRef) && readField('useOriginHeader')) {
            const collectionName = readField<string>('name', collectionRef);
            return collectionName;
          }

          return name;
        },
      },
    },
  },
};
